<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <transition name="slide" mode="out-in">
          <v-alert
            style="z-index: 1"
            v-if="err"
            prominent
            border="top"
            type="error"
          >
            <v-row align="center">
              <v-col class="grow">
                ไม่มีเลขอ้างอิง '{{ errText }}' ในระบบ
              </v-col>
              <v-col class="shrink">
                <v-btn outlined @click="err = false"
                  ><v-icon color="white" x-large
                    >mdi-close-circle</v-icon
                  ></v-btn
                >
              </v-col>
            </v-row>
          </v-alert>
        </transition>
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <!-- data table -->
        <v-row class="pa-5 mb-6">
          <v-btn
            dark
            style="background-color: rgb(27, 67, 124)"
            @click="dialog = true"
          >
            <v-icon left>mdi-card-account-details-outline</v-icon>
            ดึงเหรียญกลับแบบมีเลขอ้างอิง
          </v-btn>
        </v-row>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <div
                class="pt-0 pb-0 pl-5 pr-5"
                style="
                  background-color: rgb(27, 67, 124);
                  color: white;
                  border-radius: 7px;
                "
              >
                <v-icon color="white" left
                  >mdi-card-account-details-outline</v-icon
                >
                ดึงเหรียญกลับแบบมีเลขอ้างอิง
              </div>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col class="pl-0" cols="12">
                    <v-text-field
                      style="padding: 0 !important"
                      v-model="refId"
                      label="เลขอ้างอิง"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" class="pl-0">
                    <v-text-field
                      v-model="note"
                      style="padding: 0 !important"
                      label="หมายเหตุ*"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green"
                :disabled="!refId || !note"
                @click="getRefIdandProfileUser()"
              >
                <v-icon color="white" x-large>mdi-magnify</v-icon>
                ตกลง
              </v-btn>
              <v-btn color="red" dark @click="closeDialogRefId()">
                <v-icon class="mr-2" color="white" x-large
                  >mdi-close-circle</v-icon
                >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog3" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <div
                class="pt-0 pb-0 pl-5 pr-5"
                style="
                  background-color: rgb(27, 67, 124);
                  color: white;
                  border-radius: 7px;
                "
              >
                <v-icon color="white" left
                  >mdi-card-account-details-outline</v-icon
                >
                กรุณาใส่หมายเหตุ
              </div>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-container>
                <v-row>
                  <v-col class="pl-0" cols="12" style="display:flex;justify-content: center;font-weight: bolder;">
                    <h4 class="mr-3 mb-0" style="font-weight: bold;">ดึง {{point}} เหรียญ</h4>
                    <div><v-icon class="pb-0 mr-3">mdi-arrow-left-circle</v-icon></div>
                    <div class="mr-3"><v-list-item-avatar
                          style="border: 2px solid #dfbb9d;margin-right: 0px;margin-top: 0px;"
                        >
                          <v-img :src="dataUser.picture"></v-img>
                        </v-list-item-avatar></div>
                    <h4 class="mb-0" style="font-weight: bold;">{{dataUser.name}}</h4>
                  </v-col>
                  <v-col v-if="refID" class="pa-0" style="display:flex;"><div>*** หมายเลขอ้างอิง :</div> <div style="font-weight: bolder;" class="ml-2">{{refID}}</div></v-col>
                  <v-col cols="12" class="pl-0">
                    <v-text-field
                      v-model="note2"
                      style="padding: 0 !important"
                      label="หมายเหตุ*"
                      outlined
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#1b437c"
                class="text--white"
                :disabled="!note2"
                @click="refundCoin()"
              >
                <v-icon color="white" x-large class="pb-1">mdi-cash-refund</v-icon>
                <b style="color:white">ดึงเหรียญ</b>
              </v-btn>
              <v-btn color="red" dark @click="closeDialog3RefId()">
                <v-icon class="mr-2" color="white" x-large
                  >mdi-close-circle</v-icon
                >
                ปิด
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- end data table -->
        <v-dialog max-width="900px" style="height: 300px" v-model="dialog2">
          <template>
            <v-card class="pa-0">
              <v-toolbar
                style="font-weight: bold"
                color="#173053"
                dark
                class="pl-5"
              >
                <v-icon color="white" style="margin-right: 10px"
                  >mdi-card-account-details-outline</v-icon
                >ดึงเหรียญใช้เลขอ้างอิง</v-toolbar
              >
              <div style="display: flex">
                <v-row no-gutters>
                  <v-col
                    cols="5"
                    align="center"
                    style="align-self: center; font-weight: bold"
                    class="pb-3 pt-3 pl-8 pr-8"
                  >
                    <v-card class="pa-4" style="border: 4px solid #e0deca">
                      <div>ต้องการดึงเหรียญจำนวน</div>
                      <div>{{ point }}</div>
                      <div>เหรียญ</div>
                    </v-card>
                  </v-col>
                  <v-col
                    class="pt-0"
                    cols="2"
                    align="center"
                    style="align-self: center"
                  >
                    <!-- <v-icon color="red">mdi-cash-refund</v-icon> -->
                    <v-btn
                      dark
                      style="background-color: rgb(27, 67, 124)"
                      @click="refundCoin()"
                    >
                      <v-icon left>mdi-cash-refund</v-icon>
                      ดึงเหรียญ
                    </v-btn>
                  </v-col>
                  <v-col cols="5" align="center" class="pb-3 pt-3 pl-8 pr-8">
                    <v-card class="pa-4" style="border: 4px solid #e0deca">
                      <div style="display: flex; justify-content: center">
                        <v-list-item-avatar
                          class="mr-7"
                          style="border: 2px solid #dfbb9d"
                        >
                          <v-img :src="dataUser.picture"></v-img>
                        </v-list-item-avatar>
                        <div style="align-self: center; font-weight: bold">
                          <p class="mb-0">{{ dataUser.name }}</p>
                        </div>
                      </div>
                      <div style="align-self: center">
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 10px"
                              >mdi-card-account-details-star</v-icon
                            >ระดับสมาชิก :
                          </div>
                          <div style="display: flex">
                            <v-list-item-avatar class="ml-3 mr-2" size="25">
                              <v-img :src="dataUser.pictureUrl"></v-img>
                            </v-list-item-avatar>
                            <div style="font-weight: bold">
                              {{ dataUser.LevelName }}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 6px"
                              >mdi-alpha-c-circle-outline</v-icon
                            >เหรียญปัจจุบัน :
                          </div>
                          <div style="display: flex" class="ml-3">
                            <div style="font-weight: bold">
                              {{ dataUser.currentPoint }}
                            </div>
                          </div>
                        </div>
                        <div style="display: flex">
                          <div style="font-weight: bold">
                            <v-icon color="#7F8487" style="margin-right: 6px"
                              >mdi-cellphone</v-icon
                            >เบอร์โทรศัพธ์ :
                          </div>
                          <div style="display: flex" class="ml-3">
                            <div style="font-weight: bold">
                              {{ dataUser.tel }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </template>
        </v-dialog>
        <v-card>
          <p
            style="
              color: white;
              background-color: rgb(27, 67, 124);
              padding: 12px;
              font-weight: bold;
              letter-spacing: 3px;
            "
          >
            <v-icon dark class="pb-2" left>mdi-cash-refund</v-icon
            >ดึงเหรียญกลับแบบไม่มีเลขอ้างอิง
          </p>
          <v-row>
            <v-col cols="3">
              <v-text-field
                outlined
                v-model="tel"
                :rules="[rules.counterTel, rules.required]"
                v-mask="'###-###-####'"
                hint="ค้นหาสมาชิกโดยเบอร์โทรศัพท์"
                label="เบอร์โทรศัพท์"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-select
                outlined
                dense
                v-model="select"
                color="blue"
                :items="dataExchange"
                item-text="name"
                item-value="productExchangeRateId"
                label="สินค้า/บริการ"
              >
                <template v-slot:prepend>
                  <v-icon color="red"></v-icon> </template
              ></v-select>
            </v-col>
            <v-col cols="3" class="pr-1">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                nudge-top="21px"
                nudge-right="16px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    class="pr-1"
                    v-model="dateRangeText"
                    label="ช่วงวันที่"
                    dense
                    hint="เลือกช่วงวันที่"
                    v-bind="attrs"
                    outlined
                    readonly
                    v-on="on"
                    clearable
                    @click:clear="clearDateRange"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker1"
                  v-model="dateRange"
                  range
                  :max="new Date().toISOString().substr(0, 10)"
                  min="1950-01-01"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              align="center"
              justify="space-around"
              cols="3"
              class="pt-6 pl-6"
            >
              <v-btn
                :disabled="!tel"
                @click="searchData()"
                color="green"
                class="white--text bold--text"
                ><v-icon color="white" x-large>mdi-magnify</v-icon>ค้นหา</v-btn
              >
              <v-btn @click="clearData()" color="red" class="white--text bold--text"
                ><v-icon color="white" x-large>mdi-close-circle</v-icon
                >ยกเลิก</v-btn
              >
              
            </v-col>
          </v-row>
          <!-- <v-data-table
    item-key="name"
    class="elevation-1"
    loading
    loading-text="Loading... Please wait"
  ></v-data-table> -->
          <v-data-table
            :headers="columns"
            :items="qrCodeData"
            :items-per-page="10"
            :loading="load"
            loading-text="Loading... Please wait"
          >
            <template v-slot:[`item.picture`]="{ item }">
              <v-avatar color="primary" size="40">
                <img :src="item.picture" alt="img"
              />
         </v-avatar>
              </template>
            <template v-slot:[`item.name`]="{ item }">
              {{ item.name }}
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="#1b437c"
                    dark
                    @click.stop="openDialogRefund(item)"
                  >
                    <v-icon dark class="pb-1 mr-1"> mdi-cash-refund </v-icon>
                    <b>ดึงคะแนน</b>
                  </v-btn>
                </template>
                <span>ดึงคะแนน</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </div>
    </v-main>
  </div>
</template>
<script>
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue
  },
  created () {},
  data () {
    return {
      date: '2018-03-02',
      // path2: '/ReportQRCode/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'ดึงเหรียญกลับ',
          disabled: false,
          href: '/Tool/Refund'
        }
      ],
      note: null,
      refId: null,
      session: this.$session.getAll(),
      dialog: false,
      dialog2: false,
      dialog3: false,
      err: false,
      select: null,
      errText: null,
      // Data Table Config
      dataUser: [],
      dataItem2: [],
      dataExchange: null,
      point: null,
      body: {
        shopId: '',
        refId: '',
        note: ''
      },
      note2: null,
      qrCodeData: [],
      // Cache System
      cache: {},
      cacheTTL: 5 * 60 * 1000, // 5 minutes in milliseconds
      columns: [
        { text: 'รูปโปรไฟล์', value: 'picture' },
        { text: 'ชื่อ', value: 'name' },
        { text: 'บริการ/สินค้า', value: 'productExchangeRateName' },
        { text: 'โทเคนคิวอาร์โค้ด', value: 'token' },
        { text: 'คะแนนคิวอาร์โค้ด', value: 'point' },
        {text: 'วันที่ได้คะแนน', value: 'LAST_DATE'},
        { text: 'ดึงคะแนน', value: 'action' }
      ],
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: (value) => value.length <= 12 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      tel: null,
      productEx: null,
      dateRange: [],
      menu1: false,
      load: false,
      bodyNorefId: null,
      bodytoApi: null,
      refID: null
      // End Data Table Config
    }
  },
  computed: {
    dateRangeText() {
      if (this.dateRange && this.dateRange.length === 2) {
        const sorted = [...this.dateRange].sort()
        return `${sorted[0]} ถึง ${sorted[1]}`
      } else if (this.dateRange && this.dateRange.length === 1) {
        return this.dateRange[0]
      }
      return ''
    },
    dateStart() {
      if (this.dateRange && this.dateRange.length > 0) {
        return [...this.dateRange].sort()[0]
      }
      return null
    },
    dateEnd() {
      if (this.dateRange && this.dateRange.length === 2) {
        return [...this.dateRange].sort()[1]
      }
      return null
    }
  },
  async mounted () {
    this.getProductEx()
    this.loadCacheFromStorage()
  },
  methods: {
    getCacheKey (url) {
      return 'api_cache_' + btoa(url)
    },
    setCache (url, data) {
      const cacheKey = this.getCacheKey(url)
      const cacheData = {
        data: data,
        timestamp: Date.now()
      }
      this.cache[cacheKey] = cacheData
      try {
        localStorage.setItem(cacheKey, JSON.stringify(cacheData))
      } catch (e) {
        console.warn('Failed to save cache to localStorage:', e)
      }
    },
    getCache (url) {
      const cacheKey = this.getCacheKey(url)
      let cacheData = this.cache[cacheKey]
      
      if (!cacheData) {
        try {
          const stored = localStorage.getItem(cacheKey)
          if (stored) {
            cacheData = JSON.parse(stored)
            this.cache[cacheKey] = cacheData
          }
        } catch (e) {
          console.warn('Failed to load cache from localStorage:', e)
        }
      }
      
      if (cacheData) {
        const age = Date.now() - cacheData.timestamp
        if (age < this.cacheTTL) {
          return cacheData.data
        } else {
          this.clearCache(url)
        }
      }
      return null
    },
    clearCache (url = null) {
      if (url) {
        const cacheKey = this.getCacheKey(url)
        delete this.cache[cacheKey]
        try {
          localStorage.removeItem(cacheKey)
        } catch (e) {
          console.warn('Failed to remove cache from localStorage:', e)
        }
      } else {
        this.cache = {}
        try {
          const keys = Object.keys(localStorage)
          keys.forEach(key => {
            if (key.startsWith('api_cache_')) {
              localStorage.removeItem(key)
            }
          })
        } catch (e) {
          console.warn('Failed to clear cache from localStorage:', e)
        }
      }
    },
    loadCacheFromStorage () {
      try {
        const keys = Object.keys(localStorage)
        keys.forEach(key => {
          if (key.startsWith('api_cache_')) {
            const stored = localStorage.getItem(key)
            if (stored) {
              const cacheData = JSON.parse(stored)
              const age = Date.now() - cacheData.timestamp
              if (age < this.cacheTTL) {
                this.cache[key] = cacheData
              } else {
                localStorage.removeItem(key)
              }
            }
          }
        })
      } catch (e) {
        console.warn('Failed to load cache from localStorage:', e)
      }
    },
    async cachedAxiosGet (url) {
      const cachedData = this.getCache(url)
      if (cachedData) {
        console.log('Using cached data for:', url)
        return { data: cachedData }
      }
      
      console.log('Fetching fresh data for:', url)
      const response = await axios.get(url)

      this.setCache(url, response.data)
      
      return response
    },
    openDialogRefund (item) {
      this.point = item.point
      this.bodyNorefId = item
      this.refID = item.refId
      this.dialog3 = true
    },
    clearData () {
      this.tel = null
      this.dateRange = []
      this.select = null
    },
    clearDateRange() {
      this.dateRange = []
    },
    async searchData () {
      this.load = true
      this.qrCodeData = []
      
      // if (this.dateStart || this.dateEnd) {
        this.clearCache()
      // }
      
      setTimeout(async () => {
        const memberUrl = this.DNS_IP +
            '/member/get?shopId=' +
            this.session.data.shopId +
            '&tel=' +
            this.tel.split('-').join('').trim()
        
        await this.cachedAxiosGet(memberUrl)
          .then(async (response) => {
            if (response.data.length > 0) {
              this.dataUser = response.data[0]
              let qrcodeUrl = this.DNS_IP +
                '/qrcode/get-optimized?shopId=' +
                this.session.data.shopId +
                '&tel=' +
                response.data[0].tel +
                '&use'
              
              if (this.select) {
                qrcodeUrl += '&productExchangeRateId=' + this.select
              }
              
              // เพิ่ม date range parameters ถ้ามี
              if (this.dateStart) {
                qrcodeUrl += '&date_from=' + this.dateStart
              }
              if (this.dateEnd) {
                qrcodeUrl += '&date_to=' + this.dateEnd
              }
              
              await this.cachedAxiosGet(qrcodeUrl)
                .then((response) => {
                  if (response.data.length > 0) {
                    this.qrCodeData = response.data
                    
                    this.load = false
                  } else {
                    this.$swal('ไม่มีข้อมูลในระบบ', `ไม่มีข้อมูลในระบบคะแนนในระบบ`, 'error')
                    console.log('หาเจอ', this.load)
                    this.load = false
                  }
                })
                .catch((err) => {
                  console.log('1', err)
                  this.load = false
                })
            } else {
              this.$swal(
                'ไม่มีข้อมูลในระบบ',
                `ไม่มีเบอร์โทรนี้เป็นสมาชิกในระบบ ${this.tel}`,
                'error'
              )
              this.load = false
              console.log('หาไม่เจอ', this.load)
            }
          })
          .catch((err) => {
            console.log('2', err)
            this.load = false
          })
      }, 1500)
    },
    async getProductEx () {
      this.dataExchange = await this.getDataGlobal(
        this.DNS_IP,
        '/productExchangeRate/',
        this.session.data.shopId
      )
      console.log('dataExchange', this.dataExchange)
    },
    async getRefIdandProfileUser () {
      this.errText = this.refId
      console.log('refId', this.refId)
      console.log('note', this.note)
      const qrcodeUrl = this.DNS_IP +
            '/qrcode_by_refId?' +
            'shopId=' +
            this.$session.getAll().data.shopId +
            '&refId=' +
            this.refId
      
      await this.cachedAxiosGet(qrcodeUrl)
        .then(async (response) => {
          console.log('response', response.data[0])
          this.point = response.data[0].point
          const memberUrl = this.DNS_IP +
                '/member/get?shopId=' +
                this.$session.getAll().data.shopId +
                '&liffUserId=' +
                response.data[0].LAST_USER
          
          await this.cachedAxiosGet(memberUrl)
            .then((res) => {
              console.log('res.data[0]', res.data[0])
              this.body.shopId = this.$session.getAll().data.shopId
              this.body.refId = this.refId
              this.body.note = this.note
              this.dataUser = res.data[0]
              this.dialog2 = true
              this.dialog = false
              this.closeDialogRefId()
            })
        })
        .catch((err) => {
          console.log(err)
          this.dialog = false
          this.err = true
          this.refId = null
          this.note = null
        })
    },
    closeDialogRefId () {
      this.dialog = false
      this.refId = null
      this.note = null
    },
    closeDialog3RefId () {
      this.dialog3 = false
      this.note2 = null
      this.bodyNorefId = null
    },
    async refundCoin () {
      console.log('ffff')
      if (this.bodyNorefId) {
        this.bodytoApi = this.bodyNorefId
        this.bodytoApi['note'] = this.note2
      } else {
        this.bodytoApi = this.body
      }
      console.log(this.bodytoApi)
      await axios
        .post(this.DNS_IP + '/refund_coin', this.bodytoApi)
        .then((response) => {
          console.log(response.data)
          if (response.data.status === false) {
            this.dialog2 = false
            this.dialog3 = false
            this.$swal(
              'เลขอ้างอิงนี้ได้ดึงเหรียญกลับไปแล้ว',
              `ระบบได้ดึงเหรียญคืนจาก ${this.dataUser.name} จำนวน ${this.point} เหรียญไปแล้ว`,
              'error'
            )
          } else {
            this.dialog2 = false
            this.dialog3 = false
            if (this.bodytoApi.id) {
              this.qrCodeData = this.qrCodeData.filter(el => el.id !== this.bodytoApi.id)
            } else if (this.bodytoApi.refId) {
              this.qrCodeData = this.qrCodeData.filter(el => el.refId !== this.bodytoApi.refId)
            }
            console.log('this.qrCodeData', this.qrCodeData)
            this.$swal(
              'ดึงเหรียญเรียบร้อบ!',
              `ระบบได้ดึงเหรียญคืนจาก ${this.dataUser.name} จำนวน ${this.point} เหรียญ`,
              'success'
            )
            // Clear cache after refund to get fresh data next time
            this.clearCache()
          }
        })
        .catch((err) => {
          console.log(err)
          this.dialog = false
          this.err = true
          setTimeout(() => {
            this.err = false
            this.refId = null
            this.note = null
          }, 4000)
        })
    }
  }
}
</script>
<style scoped>
i.mdi.mdi-menu-down::before {
  color: blue;
}
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
.slide-enter-active {
  transition: 0.5s;
}
.slide-enter {
  transform: translate(100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/RefundPoint.vue